
/**
 * Module dependencies.
 */

import { camelCase, compact } from 'lodash';

/**
 * Export `getNetworkErrorTranslationPaths`.
 */

export function getNetworkErrorTranslationPaths(errorCode: string, basePath?: string): Array<string> {
  const code = camelCase(errorCode);

  return compact([
    basePath && `${basePath}.network.${code}`,
    `defaultErrors.network.${code}`,
    basePath && `${basePath}.network.defaultError`,
    'defaultErrors.network.defaultError'
  ]);
}
